import { JsonApiListResponse } from '~/redux/api/ApiTypes';
import {
  SearchType,
  SuggestionResponse,
  SuggestionsMeta,
} from '~/redux/api/evisearch/searchTypes';
import { SearchableFieldId } from '~/redux/api/methods/alert';
import { eviSearch } from '~/services/serviceInstances';

import { SuggestionsResponse } from './mergeSuggestionSources';

/** Most distinct values evisearch returns in one filter suggestions response. */
export const MAX_SUGGESTIONS_PAGE_SIZE = 1000;

export const getEvisearchSuggestions = async (
  fieldId: SearchableFieldId,
  entity: SearchType,
  substringQuery: string,
  pageSize?: number,
): Promise<SuggestionsResponse> => {
  const response = (await eviSearch.get(`/filters/${fieldId}/suggestions`, {
    params: {
      entity,
      query: substringQuery || undefined,
      'page[size]': pageSize,
    },
  })) as JsonApiListResponse<'suggestion', SuggestionResponse, SuggestionsMeta>;

  return {
    selectAllCount: response.meta?.select_all_count ?? '0',
    values: response.data.map((entity) => ({
      value: entity.attributes.value,
      display_value: entity.attributes.label,
    })),
  };
};
